import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { NavLink, Link, useNavigate } from "react-router-dom";



const PrimarySidebar = () => {
  const [showModal, setShowModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();

  const handleShow = () => setShowModal(true);
  const handleDelete = () => {
    console.log("Company profile deleted");
    setShowModal(false);
  };

  const handleIconClick = (path) => {
    if (!isExpanded) {
      setIsExpanded(true);
    }
    navigate(path);
  };

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  const menuItems = [
    { path: "/companyprofile", icon: "bx bxs-buildings", label: "Profile" },
    { path: "/LeadsDashboard", icon: "bx bxs-widget", label: "Get Leads", badge: 2 },
    { path: "/LeadCrm", icon: "bx bxs-zap", label: "Lead CRM", badge: 2 },
    { path: "/Messages", icon: "bx bxs-inbox", label: "Messages", badge: 14 },
    { path: "/Community", icon: "bx bxs-group", label: "My Community" },
  ];










  return (
    <>
      {/* Mobile toggle button */}
      <button 
        className="mobile-menu-toggle d-md-none"
        onClick={toggleSidebar}
      >
        <i className="bx bx-menu text-white"></i>
      </button>

      <div 
        className={`sidebar bg-white position-fixed ${isExpanded ? 'expanded' : 'collapsed'}`}
        onMouseEnter={() => window.innerWidth >= 768 && setIsExpanded(true)}
        onMouseLeave={() => window.innerWidth >= 768 && setIsExpanded(false)}
      >
        <div className="subMenu">
          <NavLink
            to="/MainDashboard"
            className="btn btn-link-side text-decoration-none mt-0 text-primary d-block ps-0"
          >
            <i className="bx me-1 text-primary bx-left-arrow-alt"></i>
            {isExpanded && "Back to Main Page"}
          </NavLink>

          <div className={`sub-profile mt-2 px-2 ${isExpanded ? '' : 'd-none'}`} style={{ padding: '12px 0' }}>
  <label htmlFor="domainSelect" className="form-label label_fix d-block ps-3">
    Select Company Profile
  </label>
  <select id="domainSelect" className="form-select mb-3 w-100 ps-3">
    <option value="currentDomain.com" selected>Veritis Group Inc</option>
    <option value="example.com">Wipro</option>
    <option value="mywebsite.org">ZenDesk Solutions Inc</option>
  </select>
</div>


          <ul className="px-0 list-group m-0 px-2 mt-3">
            {menuItems.map((item) => (
              <li key={item.path} className="mb-2">
                <NavLink
                  to={item.path}
                  className={({ isActive }) => (isActive ? "active text-primary" : "text-dark")}
                >
                  <button 
                    className="text-dark p-3 my-1 text-decoration-none border-0 bg-transparent w-100 text-start button-side"
                    onClick={() => handleIconClick(item.path)}
                  >
                    <i className={`${item.icon} me-2`}></i>
                    {isExpanded && (
                      <>
                        {item.label}
                        {item.badge && (
                          <span className="badge bg-default text-primary rounded-pill small ms-2 fs-6">
                            {item.badge}
                          </span>
                        )}
                      </>
                    )}
                  </button>
                </NavLink>
              </li>
            ))}
          </ul>

        </div>

      </div>
    </>
  );
};

export default PrimarySidebar;